import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Section, Popup, Text, Info, Explanation_text, GoogleLogin, Video, Select, Copy_clipboard } from '../../../components';
import Sending_limits_update_popup from './';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import ErrorIcon from '@material-ui/icons/Error';
import DeleteIcon from '@material-ui/icons/Delete';
import MessageIcon from '@material-ui/icons/QuestionAnswer';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Form, Field } from 'react-final-form';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';


const useStyles = makeStyles((theme) => ({
    link: { color: theme.palette.tertiary.main },
    error: { color: theme.palette.error.main }
}));


function Sms_section(props) {
    const[sms_setup_popup, setSMSSetupPopup]=useState();
    const[sms_delete_popup, setSMSDeletePopup]=useState();

    return (
        <Fragment>
            {(props.workspace != undefined && props.workspace.sms_logins != undefined) ?
                <Section icon={<MessageIcon color="primary"/>} title={<Typography color='primary' style={{ position: 'relative', fontWeight: 'bold', fontSize: '14px', marginTop: '5px' }}>{<span><Explanation_text inline style='small_title' color='primary' text='sms_setup_title' /></span>}<span><Info name='sms_setup' /></span></Typography>} action={<div style={{ cursor: 'pointer' }} onClick={() => { setSMSSetupPopup('NEW'); }}><AddIcon color='primary' style={{ fontSize: '20px', marginLeft: '20px' }} /></div>} maxWidth='600px'>
                    {(props.workspace.free_account != true && (props.workspace.active_subscription == null)) ?
                        <div style={{ width: '100%', marginTop: '0px', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Typography><Explanation_text inline text='sms_setup_subscribe_to_connect' /></Typography></div>
                        : (props.workspace.sms_logins != undefined && props.workspace.sms_logins.length > 0) ?
                            <Fragment>
                                <div style={{ marginTop: '-10px' }} />
                                <Sms_login id='ID' provider='Provider' username="Username" title_line />
                                <hr style={{ marginTop: '-2px' }} />
                                {props.workspace.sms_logins.map(function (sl) {
                                    return (<div style={{ position: 'relative' }}>
                                        <div style={{ position: 'absolute', top: '0px', right: '30px' }}>{(sl.error_login == true) ? <ErrorIcon color='error' style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => { setSMSSetupPopup(sl); }} /> : <EditIcon color='error' style={{ fontSize: '20px', cursor: 'pointer' }} onClick={() => { setSMSSetupPopup(sl); }} />}</div><div style={{ position: 'absolute', top: '0px', right: '5px' }}><DeleteIcon style={{ fontSize: '20px', color: '#bdbdbd', cursor: 'pointer' }} onClick={() => { setSMSDeletePopup(sl.id); }} /></div>
                                        <Sms_login id={sl.id} username={sl.username} provider={sl.provider} /></div>)
                                })}
                            </Fragment>
                            :
                            <div style={{ width: '100%', marginTop: '0px', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Button color='secondary' variant='contained' onClick={() => { setSMSSetupPopup('NEW'); }}>Connect</Button></div>
                    }
                </Section>
                :
                <Section icon={<MessageIcon color="primary"/>} title={<Typography color='primary' style={{ position: 'relative', fontWeight: 'bold', fontSize: '14px', marginTop: '5px' }}>{<span><Explanation_text inline style='small_title' color='primary' text='sms_setup_title' /></span>}<span><Info name='sms_setup' /></span></Typography>} action={<div style={{ cursor: 'pointer' }} onClick={() => { setSMSSetupPopup('NEW'); }}><AddIcon color='primary' style={{ fontSize: '20px', marginLeft: '20px' }} /></div>} maxWidth='600px'>
                </Section>
            }
            { (sms_delete_popup == undefined) ? null : <Sms_delete_popup {...props} delete_id={sms_delete_popup} handleClose={()=>{ setSMSDeletePopup(undefined);}}/>}
            { (sms_setup_popup == undefined) ? null : <Sms_setup_popup {...props} initial_sms_login={sms_setup_popup} handleClose={() => { setSMSSetupPopup(undefined) }} /> }

        </Fragment>
    )
}

//{ (calendar_delete_popup != undefined) ? <Calendar_delete_popup {...props} calendar_login_id={calendar_delete_popup} handleClose={() => { setCalendarDeletePopup(undefined); }} /> : null }
//{ (calendar_setup_popup == undefined) ? null : <Calendar_setup_popup {...props} id={calendar_setup_popup} handleClose={() => { setCalendarSetupPopup(undefined) }} /> }
//{ (calendar_setup_popup == undefined && calendar_error != undefined && calendar_error != 'ignore') ? <Calendar_error_popup {...props} calendar_error={calendar_error} handleClose={() => { setCalendarError('ignore') }} accept={(id) => { setCalendarSetupPopup(id); }} /> : null }


function Sms_delete_popup(props) {
    return (<Popup handleClose={props.handleClose} accept_button='Delete' accept_button_click={() => { props.deleteSmsLogin(props.delete_id); props.handleClose(); }} always_open title='Delete Sms Login' content={
        <div style={{ width: '95vw', maxWidth: '600px', height: '200px' }}>
            <div style={{ width: 'calc(100% - 40px)', marginLeft: '20px', marginTop: '20px', textAlign: 'center' }}><Typography>Are you sure you wish to delete this connection? It will stop working instantly.</Typography></div>
        </div>
    } />)
}

function Sms_setup_popup(props) {

    function onSubmit(params){
        if(params.initial_sms_login=='NEW'){props.createSmsLogin(params);}
        else{props.updateSmsLogin(params);}
    }

    let initial_sms_login={};
    if(props.initial_sms_login!='NEW'){initial_sms_login=props.initial_sms_login;}
    
    
    return (
        <Form
            onSubmit={onSubmit}
            initialValues={initial_sms_login}
        >
            {form_props => (
                <form onSubmit={form_props.handleSubmit}>
                    <Popup handleClose={props.handleClose} always_open title='Connect your sms provider' accept_button="Save" accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} content={
                    <div style={{ width: '95vw', maxWidth: '600px', height: '300px', marginTop: '20px' }}>
                        <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px'}}>
                            <Grid item xs={12} style={{ marginBottom: '0px' }}><Select title="SMS provider" name="provider" disabled={(props.initial_sms_login != 'NEW') ? true : false}  select_data={[{ id: 'TEXT_MAGIC', name: 'TextMagic' }]} /></Grid>
                            <Field name="provider">{(f)=>{
                                if(f.input.value == 'TEXT_MAGIC'){
                                    return (
                                        <Fragment>
                                            <Grid item xs={6} style={{marginTop:'10px'}}><Text title="API username" name="username" /></Grid>
                                            <Grid item xs={6} style={{marginTop:'10px'}}><Text title="API key" name="api_key" /></Grid>
                                            <Grid item xs={12} style={{marginTop:'10px'}}>{(initial_sms_login.webhook_path == undefined) ? undefined : <div style={{ marginTop: '0px', marginBottom: '40px', width: 'calc(100% - 20px)', marginLeft: '10px' }}><Copy_clipboard title='Webhook path' textToCopy={'https://'+window.location.hostname+'/api/sms/webhook/'+initial_sms_login.webhook_path} /></div>}</Grid>
                                        </Fragment>
                                    )
                                }}}</Field>
                        </Grid>
                    </div>
                } />
                </form>
            )}
        </Form>
    );
}

function Sms_login(props) {
    const classes = useStyles();
    return (
        <Typography variant='caption'>
            <Tooltip title={'Two way integration'}>
                <Grid container>
                    <Grid item xs={6} sm={6} style={{ fontWeight: (props.title_line == true) ? 'bold' : undefined, position: 'relative', paddingLeft: '30px', overflowX: 'hidden' }}><span style={{ position: 'absolute', left: '0px', fontWeight: (props.title_line == true) ? 'bold' : undefined }}>{props.id}</span><span style={{ position: 'relative' }}>{props.username}</span></Grid>
                    <Grid item xs={6} sm={6} style={{ overflowX: 'hidden', whiteSpace: 'nowrap', width: 'calc(100% - 10px)', fontWeight: (props.title_line == true) ? 'bold' : undefined }}><span style={{ cursor: 'pointer' }}>{props.provider}</span></Grid>
                </Grid>
            </Tooltip>
        </Typography>
    )
}

function Sms_error_popup(props) {
    return (<Popup handleClose={props.handleClose} accept_button='Fix' accept_button_click={() => { props.accept(props.calendar_error); }} always_open title='Calendar error' content={
        <div style={{ width: '95vw', maxWidth: '600px', height: '200px' }}>
            <div style={{ width: 'calc(100% - 40px)', marginLeft: '20px', marginTop: '20px', textAlign: 'center' }}><Typography>There was an error with your calendar integration. Most likely your username and password were incorrect or have been changed. To fix it try and reconnect your calendar. If this doesn't work contact us for further assistance.</Typography></div>
        </div>
    } />
    );
}



export default connect(ss, dd)(Sms_section);

function ss(state) {
    return {}
}

function dd(dispatch) {
    return {
        createSmsLogin:(params)=>{dispatch({type:'REQUEST_CREATE_SMS_LOGIN', payload:params});},
        updateSmsLogin:(params)=>{dispatch({type:'REQUEST_UPDATE_SMS_LOGIN', payload:params});},
        deleteSmsLogin:(id)=>{dispatch({type:'REQUEST_DELETE_SMS_LOGIN', id:id});},
    }
}
